import React, { useState } from "react";
import Modal from "../../../../shared/components/dashboard-layout/modalComponent";
import "./edit-group-modal.scss";

const EditGroupModal = ({ group, isOpen, onClose, onUpdateGroup, isLoading }) => {
  // Consolidated state
  const [formData, setFormData] = useState({
    groupName: group.name,
    groupDescription: group.description || "",
    // Store as comma-separated string for the input; convert to array on submit
    groupEmailRecipients: Array.isArray(group.emailRecipients)
      ? group.emailRecipients.join(", ")
      : (group.emailRecipients || ""),
    groupEmailOnEachMessage: !!group.emailOnEachMessage
  });
  const [errors, setErrors] = useState({});

  const updateFormField = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Form validation utility
  const validateForm = () => {
    const newErrors = {};
    const { groupName } = formData;

    if (!groupName.trim()) {
      newErrors.groupName = "Group name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Event handlers
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const name = String(formData.groupName || "").trim();
      const description = String(formData.groupDescription || "").trim();
      const emailRecipientsStr = String(formData.groupEmailRecipients || "").trim();
      const emailRecipients = emailRecipientsStr
        ? emailRecipientsStr.split(",").map((e) => e.trim()).filter(Boolean)
        : [];
      const emailOnEachMessage = !!formData.groupEmailOnEachMessage;
      onUpdateGroup(name, description, emailRecipients, emailOnEachMessage);
    }
  };

  const handleSave = (e) => {
    if (isLoading) return;
    handleSubmit(e);
  };

  const renderGroupNameField = () => (
    <div className="form-group">
      <label htmlFor="groupName">Group Name *</label>
      <input
        type="text"
        id="groupName"
        value={formData.groupName}
        onChange={(e) => updateFormField("groupName", e.target.value)}
        placeholder="Enter group name"
        className={errors.groupName ? "error" : ""}
        autoComplete="off"
      />
      {errors.groupName && (
        <span className="error-message">{errors.groupName}</span>
      )}
    </div>
  );

  const renderDescriptionField = () => (
    <div className="form-group">
      <label htmlFor="groupDescription">Description (Optional)</label>
      <textarea
        id="groupDescription"
        value={formData.groupDescription}
        onChange={(e) => updateFormField("groupDescription", e.target.value)}
        placeholder="Enter group description"
        rows="3"
      />
    </div>
  );

  const renderEmailRecipientsField = () => (
    <div className="form-group">
      <label htmlFor="groupName">Email Recipients (Optional)</label>
      <input
        type="text"
        id="groupName"
        value={formData.groupEmailRecipients}
        onChange={(e) => updateFormField("groupEmailRecipients", e.target.value)}
        placeholder="Enter group email recipients"
        className={errors.groupEmailRecipients ? "error" : ""}
        autoComplete="off"
      />
      {errors.groupEmailRecipients && (
        <span className="error-message">{errors.groupEmailRecipients}</span>
      )}
    </div>
  )

  const renderEmailOnEachMessageField = () => (
    <div className="form-group">
      <label className="checkbox-label" htmlFor="groupEmailOnEachMessage">
        <input
          type="checkbox"
          id="groupEmailOnEachMessage"
          checked={formData.groupEmailOnEachMessage}
          onChange={(e) => updateFormField("groupEmailOnEachMessage", e.target.checked)}
          className={"form-check-input " + (errors.groupEmailOnEachMessage ? "error" : "")}
        />
        <span className="checkmark"></span>
        Email on each message
      </label>
      {errors.groupEmailOnEachMessage && (
        <span className="error-message">{errors.groupEmailOnEachMessage}</span>
      )}
    </div>
  )

  if (!isOpen) return null;

  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      header={"Edit Group"}
      buttons={true}
      onSave={handleSave}
      saveDisabled={isLoading}
    >
      <div className="edit-group-modal">
        <form onSubmit={handleSubmit} className="modal-form" style={{ padding: "0" }}>
          {renderGroupNameField()}
          {renderDescriptionField()}
          {renderEmailRecipientsField()}
          {renderEmailOnEachMessageField()}
        </form>
      </div>
    </Modal>
  );
};

export default EditGroupModal;
